import { Card } from '@mui/material';
import styled from 'styled-components';

export const Wrapper = styled(Card)`
  padding: 24px;
  margin-bottom: 16px;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.05);
`;

export const DeviceInfoWrapper = styled.div`
  padding: 24px;
  margin-bottom: 16px;
  background-color: #ffffff;
  color: #0f172a;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.05);
`;

export const PresentationActionWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 1rem;
`;

export const ScreenshotBlock = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 1rem 0;
  align-items: center;

  img {
    width: 150px;
    cursor: pointer;
  }
`;

export const ActivityWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin: 1rem 0;
  align-items: center;
  flex-direction: column;
`;

export const ScreenshotsWrapper = styled.div`
  overflow-y: auto;
  max-height: 500px;
`;

export const ProfOfPlayWrapper = styled.div`
  display: flex;
  gap: 15px;

  @media (max-width: 960px) {
    flex-direction: column;
  }
`;

export const ScreenshotsMainWrapper = styled(Wrapper)`
  flex-grow: 2;
`;

export const ActivityMainWrapper = styled(Wrapper)`
  flex-grow: 1;
`;
